import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_PRODUCTTYPE,
  DELETE_PRODUCTTYPE,
  GET_PRODUCTTYPES,
  UPDATE_PRODUCTTYPE,
  UPDATE_PRODUCTTYPE_STATUS
} from "./actionTypes";

import {
  addProductTypeFail,
  addProductTypeSuccess,
  deleteProductTypeFail,
  deleteProductTypeSuccess,
  getProductTypesFail,
  getProductTypesSuccess,
  setState,
  updateProductTypeFail,
  updateProductTypeSuccess,
} from "./actions";

import { productTypes, updateStatus } from "../../../helpers/adipiBackendUrl";
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchProductTypes({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, productTypes, params.toString());
    yield put(setState(false));
    yield put(getProductTypesSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getProductTypesFail(error));
  }
}

function* updateProductType({ payload: productTypeObj }) {
  try {
    const { id, recordStatus, ...rest } = productTypeObj;
    yield call(patchApiCall, `${productTypes}/${id}`, rest);
    const response = yield call(getTable, `${productTypes}/${productTypeObj.id}`);
    yield put(updateProductTypeSuccess(response));
  } catch (error) {
    yield put(updateProductTypeFail(error));
  }
}

function* updateProductTypeStatus({ payload: productTypeObj }) {
  try {
    const { id } = productTypeObj;
    yield call(patchApiCall, `${productTypes}/${updateStatus}/${id}`, { recordStatus: productTypeObj.recordStatus });
    const response = yield call(getTable, `${productTypes}/${productTypeObj.id}`);
    yield put(updateProductTypeSuccess(response));
  } catch (error) {
    yield put(updateProductTypeFail(error));
  }
}

function* deleteProductType({ payload: productTypeObj }) {
  try {
    yield call(deleteApiCall, `${productTypes}/${productTypeObj.id}`);
    yield put(deleteProductTypeSuccess(productTypeObj.id));
  } catch (error) {
    yield put(deleteProductTypeFail(error));
  }
}

function* postingProductType({ payload: productType }) {
  try {
    const response = yield call(postApiCall, productTypes, productType);
    yield put(addProductTypeSuccess(response));
  } catch (error) {
    yield put(addProductTypeFail(error));
  }
}

function* productTypesSaga() {
  yield takeEvery(GET_PRODUCTTYPES, fetchProductTypes);
  yield takeEvery(ADD_NEW_PRODUCTTYPE, postingProductType);
  yield takeEvery(UPDATE_PRODUCTTYPE, updateProductType);
  yield takeEvery(UPDATE_PRODUCTTYPE_STATUS, updateProductTypeStatus);
  yield takeEvery(DELETE_PRODUCTTYPE, deleteProductType);
}

export default productTypesSaga;
